<template>
  <material-card class=pt-2 full-header>
    <template #heading>
      <v-toolbar color="accent">
        <v-toolbar-title>
          <v-icon> mdi-account-school-outline </v-icon>
          {{ course?.course_name }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn text icon dark class="mb-2" @click="close">
          <v-icon medium>mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-toolbar>
    </template>

    <v-data-table :items="studentList" :headers="studentsHeader" :loading="loading" item-key="studentID"
      :search="search" :page="pageNumber" :footer-props="{ showFirstLastPage: true}">
      <template v-slot:top>
        <v-toolbar>
          <v-toolbar-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('search')" single-line hide-details>
            </v-text-field>
          </v-toolbar-title>
          <v-divider vertical></v-divider>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text icon dark class="mb-2" v-bind="attrs" v-on="on" color="primary" @click="getStudents">
                <v-icon medium>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t("refresh") }}
            </span>
          </v-tooltip>
        </v-toolbar>
      </template>
      <!-- custom columns -->

    </v-data-table>
    <template #actions>

    </template>
  </material-card>
</template>
<script>
export default {
  name: "CourseStudents",
  props: {
    visible: Boolean,
    course: {
      type: Object,
      default: {}
    }
  },
  computed: {

  },
  data() {
    return {
      studentsHeader: [
        { text: this.$t('student_id'), value: 'student_student_id' },
        { text: this.$t('first_name'), value: 'student_firstname' },
        { text: this.$t('last_name'), value: 'student_lastname' },
        { text: this.$t('father_name'), value: 'student_father_name' },
        { text: this.$t('email'), value: 'student_email' },
        { text: this.$t('phone'), value: 'student_phone' },
        { text: this.$t('mobile'), value: 'student_mobile' },
        { text: this.$t('birth'), value: 'student_birth' },
        { text: this.$t('national_id'), value: 'student_national_id' },
        { text: this.$t('field_name'), value: 'student_field_name' },
      ],
      studentList: [],
      loading: true,
      totalServers: 0,
      options: {},
      itemPerPage: 10,
      pageNumber: 1,
      startRow: 0,
      endRow: 10,
      joinLoading: false,
      search: '',
      expanded: []
    };
  },
  watch: {

  },
  methods: {
    getStudents() {
      axios({
        url: process.env.VUE_APP_BACKEND_URL + "/api/e_learning/courses/" + this.course.id + "/enrollmentsv2",
        method: "GET",
        headers: {
          Authorization: this.$store.get("login/token"),
        },

      })
        .then((response) => {
          let data = response.data;
          this.studentList = data
          this.loading = false;
        })
        .catch((error) => {
          console.log('error', error);
        }).finally(() => {
          this.loading = false;
        });
    },

    close() {
      this.$emit('close')
    }
  },
  mounted() {
    this.getStudents();
  },
};
</script>
<style>
.text-content-left input {
  text-align: left !important;
}
</style>
  